<template>
  <vue-dialog :dialog-data="dialogData" @confirm="confirm">
    <el-form :model="dialogForm" class="label-gray" label-width="120px" :rules="rules" ref="dialogForm">
      <el-form-item label="域名（IP地址）" prop="name">
        <el-input v-model.trim="dialogForm.name" clearable></el-input>
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model.trim="dialogForm.remark" clearable></el-input>
      </el-form-item>
    </el-form>
  </vue-dialog>
</template>

<script>
  import {inputEmpty,checkIpDomain} from '@utils/validate'
  export default {
    name: "DomainOperate",
    props: {dialogData: Object},
    data() {
      return {
        dialogForm: {
          name: "",
          remark: "",
        },
        rules: {
          name: [inputEmpty("域名（IP地址）"),checkIpDomain()],
        },
      }
    },
    created() {
      let row = this.dialogData.row;
      if (row) {
        Object.keys(this.dialogForm).forEach(key => this.dialogForm[key] = this.showData(key, row, ""));
      }
    },
    methods: {
      confirm() {
        let row = this.dialogData.row;
        row ? this.revise(row) : this.add();
      },
      add() {
        this.$refs["dialogForm"].validate(async isOk => {
          if (isOk) {
            let nv = {...this.dialogForm};
            let res = await this.$Http.addDomain(nv);
            if (res) {
              this.msgSuccess("添加成功");
              this.$emit("table-reload");
              this.dialogData.visible = false;
            }
          }
        });
      },
      revise(row) {
        let nv = {};
        for(let [key, val] of Object.entries(this.dialogForm)) {
          if (val !== this.showData(key, row, "")) {
            nv[key] = val;
          }
        }
        if (Object.keys(nv).length) {
          this.$refs["dialogForm"].validate(isOk => {
            if (isOk) {
              this.openConfirm("修改该域名", async () => {
                nv.optionId = row.id;
                let res = await this.$Http.reviseDomain(nv);
                if (res) {
                  this.msgSuccess("修改成功");
                  this.$emit("table-reload");
                  this.dialogData.visible = false;
                }
              });
            }
          });
        } else {
          this.msgInfo("您尚未做任何修改")
        }
      },
    }
  }
</script>

<style scoped>

</style>
